import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { MobileMaxWidth, ResizeMediumWidth } from 'constants/Dimensions';

const VideoContainer = styled.div`
    width: 100%;
    aspect-ratio: 16 / 9;

    iframe {
        width: 100%;
        height: 100%;
        border-radius: 8px;
    }
`;

export interface IDefaultVideoFrame {
    url: string;
    width: number;
    height: number;
}

const DefaultVideoFrame = ({ url, width, height }: IDefaultVideoFrame) => {
    return (
        <VideoContainer id="container-video">
            <iframe src={`//${url}`} />
        </VideoContainer>
    );
};

export default DefaultVideoFrame;
